<template>
  <MTableCell class="m-table-cell__checkbox">
    <MCheckbox
      :value="value"
      @input="onChange"
    />
  </MTableCell>
</template>

<script>
  import MCheckbox from 'components/Inputs/Basic/MCheckbox';
  import MTableCell from 'components/Data/Tables/MTable/cells/MTableCell';

  export default {
    name: 'MTableCellCheckBox',
    components: {MTableCell, MCheckbox},
    props: {
      itemKey: {
        type: String,
        default: ''
      },
      tableRow: {
        type: Object,
        default: Object
      },
      uniqueKeyAttr: {
        type: String,
        required: true
      },
      selectedIdsSet: {
        type: Set,
        required: true
      },
      selectedIds: {
        type: Array,
        required: true
      }
    },
    computed: {
      value () {
        return this.selectedIdsSet.has(this.tableRow[this.uniqueKeyAttr]);
      }
    },
    methods: {
      onChange (val) {
        this.$emit('change', {
          [this.uniqueKeyAttr]: this.tableRow[this.uniqueKeyAttr],
          item: this.itemKey,
          value: val
        });
      }
    }
  };
</script>

<style>
  .m-table-cell__checkbox .m-checkbox .m-checkbox__check-mark {
    margin: 1px;
  }

  .m-table-cell__checkbox .m-checkbox .m-checkbox__icon {
    margin: 0;
  }
</style>
